import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { getStationTimingDayGroupId } from "./station-timing-preview.utils";

interface IStationTimingDayToggleProps {
  legIndex: number;
  /** "1. A - B" text of the leg; the only thing that tells two day expanders apart by ear. */
  legName: string;
  daysCount: number;
  isExpanded: boolean;
  onToggle: (legIndex: number) => void;
}

export const StationTimingDayToggle: FC<IStationTimingDayToggleProps> = ({
  legIndex,
  legName,
  daysCount,
  isExpanded,
  onToggle,
}) => {
  const { t } = useTranslation();
  const handleClick = useEvent((): void => {
    onToggle(legIndex);
  });

  return (
    <button
      type="button"
      className="station-timing__day-toggle"
      aria-expanded={isExpanded}
      aria-controls={getStationTimingDayGroupId(legIndex)}
      aria-label={
        isExpanded
          ? t("stationTiming.HIDE_DAY_BREAKDOWN_ARIA", { leg: legName })
          : t("stationTiming.SHOW_DAY_BREAKDOWN_ARIA", { leg: legName })
      }
      onClick={handleClick}
    >
      {/* The caret only repeats what aria-expanded already says, so it stays out of the a11y tree. */}
      <span className="station-timing__expander-caret" aria-hidden="true">
        {isExpanded ? "▾" : "▸"}
      </span>
      {isExpanded
        ? t("stationTiming.HIDE_DAY_BREAKDOWN")
        : t("stationTiming.SHOW_DAY_BREAKDOWN", { daysCount })}
    </button>
  );
};
